import { FC, useRef, useState } from 'react'
import styled, { css } from 'styled-components'
import SelectBox from '@app.feature/careerManage/desktop/careerContent/components/inputFields/select/components/SelectBox'
import SelectOption, {
  TOptionsValue,
} from '@app.feature/careerManage/desktop/careerContent/components/inputFields/select/components/SelectOption'
import { useOutSideClick } from 'hooks/useOutSideClick'

interface IFProps {
  defaultSelectOption?: TOptionsValue | null
  options: Array<TOptionsValue>
  placeholder?: string
  errorMessage?: string
  isErrors?: boolean
  disabled?: boolean
  onChangeSelect: (selectValue: string) => void
}

const PredictionInputSelect: FC<IFProps> = ({
  options,
  isErrors,
  placeholder = '선택',
  errorMessage,
  defaultSelectOption,
  disabled,
  onChangeSelect,
}) => {
  const selectRef = useRef<HTMLDivElement>(null)

  const [isShowOption, setIsShowOption] = useState<boolean>(false)

  const handleSelectOption = (selectedOption: TOptionsValue) => {
    onChangeSelect(selectedOption.value)
    setIsShowOption(false)
  }

  const handleShowOption = () => {
    setIsShowOption((value) => !value)
  }

  const handleOutsideClick = () => {
    setIsShowOption(false)
  }

  const valueHasIcon = options?.find(
    (option) => option?.label === defaultSelectOption?.label,
  )?.icon

  useOutSideClick({
    ref: selectRef,
    isActive: isShowOption,
    onOutsideClick: handleOutsideClick,
  })

  return (
    <StyledWrapper>
      <div className="select-container" ref={selectRef}>
        <SelectBox
          placeholder={placeholder}
          isErrors={isErrors || !!errorMessage}
          icon={valueHasIcon}
          disabled={disabled}
          isFocused={isShowOption}
          selectValue={defaultSelectOption?.label || ''}
          onClick={handleShowOption}
        />
        {isShowOption && options?.length > 0 && (
          <SelectOption
            className="select-options"
            options={options}
            onClick={handleSelectOption}
          />
        )}
      </div>
    </StyledWrapper>
  )
}

export default PredictionInputSelect

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    width: 200px;
    height: 50px;
    & > .select-container {
      width: 200px;
      position: relative;
      cursor: pointer;
      li {
        height: 50px;
        > p {
          font-size: 16px;
          font-weight: 500;
          letter-spacing: -0.64px;
        }
      }
      > div {
        & > [aria-describedby='placeholder'] {
          font-weight: 500;
          color: ${theme.color.text_2};
        }
      }
    }

    .select-options {
      & > li {
        display: flex;
        align-items: flex-start;
        height: auto;
        p {
          height: auto;
          text-align: left;
          color: ${theme.color.text_1};
          word-break: break-word;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  `}
`
